export const FALLBACK_SEO = {
  title: 'Octoberweb',
  description: 'Octoberweb website',
  icon: '/favicon.svg',
};
